module.exports = __webpack_public_path__ + "fc6e0ed8c6e7fed37db2291a2fcd8285.pdf";